export default __webpack_public_path__ + "static/media/we-are-trova.1fd47ddf.png";